import {Component, Inject, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RdsModalComponent} from 'src/app/shared/rds/rds-modal.component';

@Component({
    selector: 'store-cabecalho-pesquisa',
    templateUrl: '../../../home/home/cabecalho/cabecalho.component.html',
    styleUrls: ['../../../home/home/cabecalho/cabecalho.component.scss']
})
export class CabecalhoPesquisaComponent implements OnInit {

    @Input()
    public tagsPesquisa: Array<string>;
    @Output()
    public enviaTag = new EventEmitter();

    @ViewChild('tag', {static: false}) tag: ElementRef;

    constructor(private router: Router, @Inject(DOCUMENT) private document: Document, private modalService: NgbModal) {
    }

    ngOnInit() {
        this.document.getElementById('app-header').className = 'header-pesquisa sticky-top';
    }

    home() {
        this.router.navigate(['/home']);
        this.document.getElementById('divBody').className = 'home';
    }

    solicitarDemonstracao(): void {
        this.modalService.open(RdsModalComponent);
    }

    pesquisar(tag) {
        if (tag) {
            this.enviaTag.emit(tag);
            this.tag.nativeElement.value = '';
            this.tag.nativeElement.focus();
        }
    }
}
